import { render } from "./faq.vue?vue&type=template&id=380c4b20&ts=true"
import script from "./faq.ts?vue&type=script&lang=ts&external"
export * from "./faq.ts?vue&type=script&lang=ts&external"

import "./faq.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__